import React from 'react';
import { Hint, Inscription, WarningIcon } from '@common-fe/common-fe';

interface Props {
  message: string;
  hideStyle?: React.CSSProperties;
  iconSize?: string;
}

const WarnIconWithText: React.FC<Props> = ({ iconSize, message, hideStyle }) => (
  <Hint
    hintElement={(
      <WarningIcon color="danger" {...iconSize ? { size: iconSize } : {}} />
    )}
    contentStyles={{ maxWidth: '185px', ...hideStyle }}
  >
    <Inscription size="12px" weight={500} lineHeight="18px">{message}</Inscription>
  </Hint>
);

export default WarnIconWithText;
